module.exports = __webpack_public_path__ + "static/media/loading_b.91783bf4.png";